import { hideScrollbar } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { borderRadius, colors, spacing, typography } = themeVariables;

/* No sizing token for an image tile. */
const TILE_SIZE = '142px';

export const section = css`
  display: flex;
  flex-direction: column;
  row-gap: var(${spacing.md});
`;

/** Body type on a heading: the design sets this as a label, not a heading in the type scale. */
export const heading = css`
  margin: 0;
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.lg.fontSize});
  font-weight: 700;
  line-height: var(${typography.body.sizes.lg.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
  color: var(${colors.content.default});
`;

export const track = css`
  display: flex;
  gap: var(${spacing.xs});
  margin: 0;
  padding: 0;
  overflow-x: auto;
  overscroll-behavior-x: contain;
  scroll-snap-type: x mandatory;
  list-style: none;
  ${hideScrollbar}
`;

export const item = css`
  flex: 0 0 auto;
  scroll-snap-align: start;
`;

export const tile = css`
  display: block;
  width: ${TILE_SIZE};
  height: ${TILE_SIZE};
  overflow: hidden;
  border-radius: var(${borderRadius.md.mobile});
  background-color: var(${colors.surface.disabled});
`;

export const image = css`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
